module.exports = __webpack_public_path__ + "images/ds-landing-bi-work-3.webp";